module.exports = __webpack_public_path__ + "static/surveillance@2x-af4474743288e437d50ba5826899a339.jpg";